import { Loader } from "@itandi/itandi-bb-ui/Loader";
import type { NextPage } from "next";
import { useRouter } from "next/router";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/components/specifics/deals/[id]/related_deals/new/Page";
import useItandiAccount from "~/hooks/useItandiAccount";
import { ItandiAccountContext } from "~/models/ItandiAccount";
import { parseId } from "~/utils/ParseId";

export const PATH = (id: number): string => `/deals/${id}/related_deals/new`;

const New: NextPage = () => {
	const { data: account } = useItandiAccount().currentAccount();
	const router = useRouter();
	const id = parseId(router.query.id);
	if (!router.isReady || account === null) return <Loader />;

	return (
		<>
			<NskHead title="関連する案件追加" />
			<ItandiAccountContext.Provider value={account}>
				<Component dealId={id} />
			</ItandiAccountContext.Provider>
		</>
	);
};

export default New;
